import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Serve un'app per usare la carta?",
    a: "No. Basta avvicinare uno smartphone con NFC (la quasi totalità dei telefoni moderni) o inquadrare il QR code con la fotocamera. Si apre direttamente la pagina recensioni di Google, senza installare nulla.",
  },
  {
    q: "Ci sono costi mensili o abbonamenti?",
    a: "Assolutamente no. Acquisti la carta o l'espositore una sola volta e funziona per sempre. Nessun canone, nessun rinnovo, nessuna sorpresa.",
  },
  {
    q: "Come collegate la carta alla mia attività?",
    a: "Pensiamo a tutto noi: ci invii su WhatsApp il link recensioni della tua scheda Google (ti spieghiamo come trovarlo in un minuto) e ti consegniamo il prodotto già programmato e testato.",
  },
  {
    q: "E se un cliente ha un telefono senza NFC?",
    a: "Nessun problema: ogni prodotto include anche il QR code stampato ad alta definizione. Qualsiasi smartphone con fotocamera può lasciare la recensione.",
  },
  {
    q: "Posso personalizzare carte ed espositori?",
    a: "Sì, possiamo personalizzare grafica e configurazione in base alle tue esigenze. Scrivici su WhatsApp e costruiamo insieme la soluzione giusta per il tuo locale.",
  },
  {
    q: "Spedite in tutta Italia?",
    a: "Sì, spediamo in tutta Italia con corriere tracciato. Scrivici su WhatsApp per tempi di consegna e disponibilità immediata.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-3xl px-5 py-24 sm:py-32">
    <Reveal className="text-center">
      <span className="rounded-full bg-blue-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#4285F4]">
        Domande frequenti
      </span>
      <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
        Tutto chiaro, prima ancora di chiedere.
      </h2>
    </Reveal>
    <Reveal delay={0.15} className="mt-12">
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i + 1}`} className="border-slate-200">
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="font-display text-left text-base font-bold text-slate-900 hover:text-[#4285F4] sm:text-lg">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-slate-600 sm:text-base">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
